"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SearchWithSort = function SearchWithSort(_ref) {
  var partList = _ref.partList,
    onchange = _ref.onchange,
    id = _ref.id,
    className = _ref.className,
    placeholder = _ref.placeholder,
    listEnable = _ref.listEnable,
    defaultSystem = _ref.defaultSystem;
  var Option = _antd.Select.Option;
  return /*#__PURE__*/_react.default.createElement(_antd.Select, {
    className: className,
    onChange: function onChange(e) {
      return onchange(id, e);
    },
    showSearch: true,
    style: {
      width: "100%"
    },
    placeholder: placeholder,
    optionFilterProp: "children",
    filterOption: function filterOption(input, option) {
      var _option$children;
      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : _option$children.toLowerCase().indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    filterSort: function filterSort(optionA, optionB) {
      var _optionA$children, _optionB$children;
      return optionA === null || optionA === void 0 ? void 0 : (_optionA$children = optionA.children) === null || _optionA$children === void 0 ? void 0 : _optionA$children.toLowerCase().localeCompare(optionB === null || optionB === void 0 ? void 0 : (_optionB$children = optionB.children) === null || _optionB$children === void 0 ? void 0 : _optionB$children.toLowerCase());
    },
    defaultValue: listEnable ? defaultSystem : null,
    disabled: listEnable
  }, partList === null || partList === void 0 ? void 0 : partList.map(function (part, index) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: JSON.stringify(part),
      key: part === null || part === void 0 ? void 0 : part.system_id
    }, (part === null || part === void 0 ? void 0 : part.system_id) + " " + (part === null || part === void 0 ? void 0 : part.model_number));
  }));
};
var _default = SearchWithSort;
exports.default = _default;